import type { VendorFile } from './types';

/**
 * Known vendor display labels. Keyed loosely (not `Record<VendorKey,
 * string>`) because `SpaRequestResponse.vendor` is a free-form backend
 * string - callers look up by that raw value and fall back to it when
 * unrecognized, so the map must accept any string without a cast.
 */
export const VENDOR_LABELS: Readonly<Record<string, string>> = {
  hoffman: 'Hoffman',
  abb: 'ABB',
  rockwell: 'Rockwell',
  schneider: 'Schneider',
  '3m': '3M',
  hubbell: 'Hubbell',
};

export const DIVISIONS = ['Westburn', 'Nedco', 'Lumen', 'Westburn West'];

export function fileSourceLabel(src: VendorFile['source']): string {
  switch (src) {
    case 'siman':
      return 'Siman SSO';
    case 'fiori':
      return 'Fiori (Rockwell)';
    case 'se_advantage':
      return 'SE Advantage';
    case 'attachment':
      return 'Request attachment';
  }
}
